import { configureStore } from '@reduxjs/toolkit'

import serverDateReducer from './features/serverDate'
import participantReducer from './features/participant'
import intervalsReducer from './features/intervals'
import absenceReasonsReducer from './features/absences'
import learningReducer from './features/learning'
import sessionReducer from './features/session'
import entrysReducer from './features/entrys'


export const store = configureStore({
    reducer: {
        serverDate: serverDateReducer,
        participant: participantReducer,
        intervals: intervalsReducer,
        absenceReasons: absenceReasonsReducer,
        learning: learningReducer,
        session: sessionReducer,
        entrys: entrysReducer
    },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch